export default "__VITE_ASSET__DLvurlyt__"